//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import {mapActions, mapGetters} from "vuex";

import Multiselect from 'vue-multiselect'

import { BModal, BVModalPlugin } from 'bootstrap-vue'

import Vue from 'vue'
Vue.use(BVModalPlugin)

export default {

    name: 'CategoryTag',

    components: {
        Multiselect, BModal
    },

    props: {
        seo: {
            type: Boolean,
            default: false
        },
        seoFilter: {
            type: String,
        },
        seoCountry: {
            type: String,
        },
        seoCountrySlug: {
            type: String,
        },
    },

    watch: {
        $route(to, from) {
          this.checkQueryFilter()
        },
    },

    data() {
        return {
            isFocused: false,
            left: null,
            bottom: null,
            filter: [],
            supplierServices: [],
            hotelServices: [],
            hotelStars: false,
            hotelRooms: '',
        };
    },

    async fetch() {

        try {
            const response = await this.doServices()
            this.checkQueryFilter()
        } catch (e) {
            this.$logger.captureException(e)
        }

    },

    methods: {

        ...mapActions('search', {
            doServices: 'doServices',
        }),

        filterHotelServices() {

            if(this.hotelStars || this.hotelRooms || this.hotelServices.length) {

                var queryObject = {
                    'types': ['hotel']
                }

                if(this.hotelStars) {
                    queryObject['star_rating'] = this.hotelStars
                }

                if(this.hotelRooms) {
                    queryObject['hotel_rooms'] = this.hotelRooms
                }

                if(this.hotelServices.length) {
                    var services = []

                    this.hotelServices.forEach(service => {
                        services.push(service.value)
                    })
                    queryObject['services'] = services
                }

                var filterQuery = JSON.stringify(queryObject)

                this.routeToFilter(filterQuery)

                return
            }

            this.clearFilter()
            this.addFilter('hotel')

        },

        filterSupplierServices() {

            if(this.supplierServices.length) {

                var queryObject = {
                    'types': ['supplier']
                }

                var services = []

                this.supplierServices.forEach(service => {
                    services.push(service.value)
                })
                queryObject['services'] = services

                var filterQuery = JSON.stringify(queryObject)

                this.routeToFilter(filterQuery)

                return
            }

            this.clearFilter()
            this.addFilter('supplier')

        },

        clearSupplierServices() {
            this.supplierServices = []
        },

        clearHotelServices() {
            this.hotelStars = false
            this.hotelRooms = ''
            this.hotelServices = []
        },

        checkQueryFilter() {

            if(this.queryFilter) {

                try {

                    //const queryFil = JSON.parse(this.queryFilter);

                    this.clearFilter()

                    const [err, queryFil] = this.$helper.safeJsonParse(this.queryFilter)

                    if(err) {
                        return
                    }

                    if(typeof queryFil.types !== 'undefined' && queryFil.types.length) {

                        queryFil.types.forEach(filter => {

                            if(filter != '') {
                                this.filter.push(filter)
                            }

                        })

                    }


                    if(typeof queryFil.services !== 'undefined' && queryFil.services.length) {

                        const actFilter = this.filter[0]

                        queryFil.services.forEach(service => {

                            if(service != '') {

                                var selService = this.servicesType(actFilter).find(type => type.value === service)

                                if(actFilter === 'hotel') {
                                    if(selService) {
                                        this.hotelServices.push(selService)
                                    }
                                } else {
                                    if(selService) {
                                        this.supplierServices.push(selService)
                                    }
                                }
                            }

                        })

                    }


                    if(typeof queryFil.star_rating !== 'undefined' && queryFil.star_rating > 0) {
                        this.hotelStars = queryFil.star_rating
                    }

                    if(typeof queryFil.hotel_rooms !== 'undefined' && queryFil.hotel_rooms > 0) {
                        this.hotelRooms = queryFil.hotel_rooms
                    }


                    if(!this.filter.length) {
                        this.resetFilterRedirect()
                    }

                } catch (error) {
                    this.$logger.captureException(error)
                    this.resetFilterRedirect()
                }

            } else {
                this.clearFilter()
            }

        },

        addFilter(filter) {

            const found = this.filter.find(el => el == filter)

            if(found) {
                return
            }

            this.filter.push(filter)

            const filterQuery = this.getFilterQuery()

            this.routeToFilter(filterQuery)
        },

        toggleFilter(filter) {

            if(this.$waiter.has('search.do')) {
                return
            }

            let found;

            if(this.seo === true) {
                found = this.seoFilter === filter
            } else {
                found = this.filter.find(el => el == filter)
            }


            if(found) {
                this.resetFilterRedirect()
                return
            } else {
                this.clearFilter()
                this.filter.push(filter)
            }

            const filterQuery = this.getFilterQuery()
            this.routeToFilter(filterQuery)

        },

        toggleFilterOld(filter) {

            if(this.$waiter.has('search.do')) {
                return
            }

            const found = this.filter.find(el => el == filter)

            if(found) {
                const index = this.filter.indexOf(found)
                if (index > -1) {
                    this.filter.splice(index, 1);
                }
            } else {
                this.filter.push(filter)
            }

            if(!this.filter.length) {
                this.resetFilter()
            } else {

                const filterQuery = this.getFilterQuery()
                this.routeToFilter(filterQuery)

            }

        },

        getFilterQuery() {
            return '{"types": ["'+ this.filter.join('","') +'"]}'
        },

        getSeoRedirectPath() {
            const { href } = this.$router.resolve({ name: 'search.type.country', params: { type: 'country', term: this.seoCountry, slug: this.seoCountrySlug }})
            return href
        },

        routeToFilter(filterQuery) {

            const currentPath = this.$router.currentRoute.path
            let routeParams, newPath;

            if(this.seo === true) {
                newPath = this.getSeoRedirectPath()
            } else {
                newPath = currentPath.replace(/\/page\/\d+/gi, '')
            }

            if(this.queryQ) {
                routeParams = { path: newPath, query: {q: this.queryQ, filter: filterQuery} }
            } else {
                routeParams = { path: newPath, query: {filter: filterQuery} }
            }

            const resolved = this.$router.resolve(routeParams)

            if(resolved.route.fullPath !== this.$router.currentRoute.fullPath) {
                this.$router.push(routeParams)
            }

        },

        filterActive(filter) {

            if(this.seo === true) {
                return this.seoFilter === filter
            }

            return this.filter.find(el => el == filter)
        },

        resetFilterRedirect() {
            this.clearFilter()

            const fullPath = this.$router.currentRoute.fullPath

            let currentPath

            if(this.seo === true) {
                currentPath = this.getSeoRedirectPath()
            } else {
                currentPath = this.$router.currentRoute.path
            }

            if(this.queryQ) {
                currentPath = currentPath + '?q=' + this.queryQ
            }

            if(currentPath !== fullPath) {
                this.$router.push({ path: currentPath})
            }
        },

        clearFilter() {
            this.filter = []
            this.clearSupplierServices()
            this.clearHotelServices()
        },

        setActive(index) {
            this.isActiveted = index;
        },

    },

    computed: {

        ...mapGetters('search', ['servicesType', 'services']),

        filterAllActive() {

            if(this.seo === true) {
                return false
            }

            return !this.filter.length

        },

        isLoading() {
            return this.isSearchLoading && this.isServicesLoading
        },

        isSearchLoading() {
            return this.$waiter.has('search.do')
        },

        isServicesLoading() {
            return this.$waiter.has('search.services')
        },

        queryFilter() {
            return this.$route.query.filter
        },

        queryQ() {
            return this.$route.query.q
        },

        isCrawler() {
            return this.$store.state.isCrawler
        },

    },

}
